<template>
  <portal v-if="show" to="modal" :order="order">
    <transition
      appear
      name="modal-backdrop"
      mode="out-in"
      @enter="onEnter"
      @leave="onLeave"
    >
      <div class="modal" to="modal">
        <div class="modal__content" :class="classNames">
          <slot></slot>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: "UiModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return ["xs", "sm", "md", "lg", "xl"].includes(value);
      },
    },
    order: {
      type: Number,
      default: 1,
    },
    centered: Boolean,
    escape: Boolean,
    closeByBackdrop: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classNames() {
      return [
        `modal__content--${this.size}`,
        this.centered && "modal__content--center",
      ];
    },
  },
  watch: {
    show(val) {
      this.lockWindow(val);
    },
  },
  mounted() {
    if (this.escape && this.closeByBackdrop) {
      document.addEventListener("keyup", this.onKeyUp);
    }
  },
  methods: {
    lockWindow(show) {
      const body = document.querySelector("body");
      if (show) {
        body.classList.add("overflow-hidden", "pr-3.5");
      } else {
        setTimeout(() => {
          body.classList.remove("overflow-hidden", "pr-3.5");
        }, 300);
      }
    },
    onEnter() {
      this.$emit("show");
    },
    onLeave() {
      this.$emit("close");
    },
    clickBackdrop() {
      if (this.closeByBackdrop) {
        this.onLeave();
      }
    },
    onKeyUp(e) {
      const evt = e || window.event;
      if (evt.keyCode === 27) {
        this.onLeave();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal {
  @apply fixed flex h-full w-full;
  top: 0;
  left: 0;
  z-index: 99990;
  background-color: rgba(black, 0.6);

  &--center {
    @apply items-center;
  }
  &__content {
    @apply fixed m-auto grid w-11/12 flex-col py-10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    @screen md {
      @apply w-full;
    }
    /*  size */
    &--xs {
      max-width: 320px;
    }
    &--sm {
      max-width: 480px;
    }
    &--lg {
      max-width: 800px;
    }
    &--xl {
      max-width: 960px;
    }
    /* centered */
    &--center {
      height: fit-content;
      @apply py-10;
    }
  }
}
.modal-backdrop-enter-active,
.modal-backdrop-leave-active {
  @apply transition-opacity duration-500;
}
.modal-backdrop-enter,
.modal-backdrop-leave-to /* .fade-leave-active below version 2.1.8 */ {
  @apply opacity-0;
}
// modal content animation
.modal-backdrop-enter-active .modal__content {
  @apply transition-all duration-300 ease-out;
}
.modal-backdrop-enter .modal__content {
  @apply transform translate-y-3 opacity-0;
}
.modal-backdrop-leave-active .modal__content {
  @apply transform translate-y-3 opacity-0 transition-all duration-300;
}
</style>
